import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import httpRequest from "services/httpRequest";
import snakecaseKeys from "snakecase-keys";
import { getNewNotifications } from "useFirebase/useFireStore";

const _urlPrefix = "/notification";

export const fetchNotificationPaging = createAsyncThunk(
  "notification/fetchNotificationPaging",
  async params => {
    const result = await httpRequest({
      url: `/api${_urlPrefix}`,
      params: snakecaseKeys(params),
      method: "GET",
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const reduceReadAllNotifications = createAsyncThunk(
  "notification/reduceReadAllNotifications",
  async () => {
    const result = await httpRequest({
      url: `/api${_urlPrefix}/read`,
      method: "PUT",
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const fetchRealTimeMessagePaging = createAsyncThunk(
  "notification/fetchRealTimeMessagePaging",
  async (params, { dispatch }) => {
    const { userId } = params;
    await getNewNotifications(userId, dispatch);
  }
);

export const reduceReadNotification = createAsyncThunk(
  "notification/reduceReadNotification",
  async (params, { dispatch }) => {
    const result = await httpRequest({
      url: `/api${_urlPrefix}/read/${params.id}`,
      method: "PUT",
    });
    if (!result) {
      return;
    }
    await dispatch(fetchNotificationPaging(params.request));
    await dispatch(reduceUnReadNotification({ type: "NOTICE" }));
    return result.data;
  }
);

export const reduceUnReadNotification = createAsyncThunk(
  "notification/reduceUnReadNotification",
  async params => {
    const result = await httpRequest({
      url: `/api${_urlPrefix}/unread`,
      params: params,
      method: "GET",
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

const initialState = {
  list: [],
  count: 0,
  notification: {},
};

const slice = createSlice({
  name: "notification",
  initialState: initialState,
  reducers: {
    addNotificationCount: state => {
      state.count = state.count + 1;
    },
    resetNotificationCount: state => {
      state.count = 0;
    },
    resetRealTimeNotification: state => {
      state.list = [];
    },
    updateListNotification: (state, action) => {
      const { payload } = action;
      const newList = payload.filter(item => item.type === "NOTICE" && item);
      state.list = newList.map(item => {
        return {
          ...item,
          status: item.status.toString(),
        };
      });

      // Set notification to show toast message notification
      if (payload[0].type === "NEW_MESSAGE") {
        state.notification = payload[0];
      }
    },
  },
  extraReducers: {
    [reduceUnReadNotification.fulfilled]: (state, action) => {
      state.count = action.payload;
    },
  },
});

const { reducer, actions } = slice;
export const {
  addNotificationCount,
  updateListNotification,
  resetNotificationCount,
  resetRealTimeNotification,
} = actions;

export default reducer;

export const getNotificationList = createSelector(
  state => state.notification.list,
  list => list
);

export const getNotificationCount = createSelector(
  state => state.notification.count,
  count => count
);

export const getNotification = createSelector(
  state => state.notification.notification,
  notification => notification
);
